var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is the Management Page here")]),_vm._l((_vm.persons),function(person){return _c('div',[_vm._v(" "+_vm._s(person.name)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }